// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";

type $Props = {
  classes: Object,
  headline: string | null,
};

const TipsHeadline = ({ classes, headline }: $Props) => {
  return (
    <div className={classes.root}>
      <Typography
        style={{ fontWeight: "400" }}
        className={classes.heading}
        type="title"
      >
        {headline}
      </Typography>
    </div>
  );
};

const styles = (theme) => {
  return {
    root: {
      width: "100%",
      maxWidth: "660px",
      margin: "auto",
    },
    heading: {
      fontSize: "28px",
      [theme.breakpoints(700)]: {
        fontSize: "32px",
      },
    },
  };
};

export default withStyles(styles)(TipsHeadline);
